export default function DisclaimerSection() {
  return (
    <section className="w-full px-6 md:px-10 py-14 bg-foreground-900/95">
      <div className="max-w-4xl mx-auto text-center">
        <div className="w-12 h-12 flex items-center justify-center rounded-full bg-foreground-800 text-background-50/60 mx-auto mb-5">
          <i className="ri-shield-line text-xl"></i>
        </div>
        <p className="text-background-50/70 text-sm leading-relaxed max-w-3xl mx-auto">
          We are an independent informational website providing research, guides, and educational resources about Sugargoo Spreadsheet. We are <strong className="text-background-50/90">not Sugargoo</strong>, do not operate warehouses, process payments, or sell products. Users should independently verify sellers and product information before purchasing. This site may contain affiliate links.
        </p>
        <div className="flex flex-wrap items-center justify-center gap-5 mt-6">
          <a href="#" className="text-xs text-background-50/50 hover:text-primary-400 transition-colors whitespace-nowrap">Privacy Policy</a>
          <span className="text-background-50/30">·</span>
          <a href="#" className="text-xs text-background-50/50 hover:text-primary-400 transition-colors whitespace-nowrap">Terms of Service</a>
          <span className="text-background-50/30">·</span>
          <a href="#" className="text-xs text-background-50/50 hover:text-primary-400 transition-colors whitespace-nowrap">Affiliate Disclosure</a>
          <span className="text-background-50/30">·</span>
          <a href="#" className="text-xs text-background-50/50 hover:text-primary-400 transition-colors whitespace-nowrap">Security Statement</a>
        </div>
      </div>
    </section>
  );
}